import "@/App.css";
import OperatorApp from "@/operator/OperatorApp.jsx";

function App() {
  return <OperatorApp />;
}

export default App;
